export default {
  'ADMIN_ROLE' (state) {
    return state.admin_role
  },
  'ADMIN_ROLES' (state) {
    return state.admin_roles
  }
}
